<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e1705"><b>Dedication </b></p>
<p class="tx" id="d6hy7e1705"><i>To Rhonda Montgomery, Patricia Moody, </i><i>Sande Johnson, and Nancy Forsyth </i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c5_r1.vue?3f5ceaec